module.exports = {
  model: {id: '', vehicle_id: null, quantity: 0, value: 0}
}
